import { render, staticRenderFns } from "./RemoteDocumentWarning.vue?vue&type=template&id=376704c2"
import script from "./RemoteDocumentWarning.vue?vue&type=script&lang=js"
export * from "./RemoteDocumentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports